import { Routes, RouterModule } from '@angular/router';
import { ScheduleJobComponent } from './schedulejob.component';

const routes: Routes = [
    {
        path: '',
        component: ScheduleJobComponent
    },
];

export const ScheduleJobRoutes = RouterModule.forChild(routes);
